import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f45cfb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "family-group-manage" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "nameInput",
  class: "form-label"
}, " Group name ", -1))
const _hoisted_3 = { class: "owner-area" }
const _hoisted_4 = { class: "form-label" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Created", -1))
const _hoisted_6 = { class: "input-value" }
const _hoisted_7 = { class: "date-relative" }
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = {
  key: 0,
  type: "button",
  id: "confirmDelete",
  class: "btn btn-danger btn-sm",
  "data-bs-toggle": "modal",
  "data-bs-target": "#deleteModal"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to delete this group?")
], -1))

import { computed, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useFamilyGroupStore } from '@/gp/FamilyGroupStore'
import { LoadMode } from '@/util/AsyncData'
import { FamilyGroup, ItemPermissions } from '@/gp/GroupAdminModel'
import { useInstantSave } from '@/util/InstantSave'
import { DateTimeUtil } from '@/util/LuxonUtil'
import { Trash2Icon } from '@zhuowenli/vue-feather-icons'
import { notImplemented } from '@/util/AppUtil'
import InPlaceTextEdit from '@/util/InPlaceTextEdit.vue'
import UserItem from '@/manage/users/UserItem.vue'
import Modal from '@/util/Modal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupManage',
  props: {
    familyGroupId: {}
  },
  setup(__props: any) {

const props = __props;



const deleteModalRef = ref<InstanceType<typeof Modal>>()

const familyGroupStore = useFamilyGroupStore()
const router = useRouter()

const familyGroupRef = computed(() => familyGroupStore.getAsyncGroup(props.familyGroupId, LoadMode.EnsureLoaded)?.data)
const permissionsRef = computed(() => familyGroupStore.getAsyncPermissions(props.familyGroupId, LoadMode.EnsureLoaded)?.data)
const canEditRef = computed(() => (permissionsRef.value ?? 0) & ItemPermissions.Modify)

async function deleteGroup() {
  await familyGroupStore.deleteAsync(props.familyGroupId!)
  deleteModalRef.value?.close()
  router.push("/groups")
}

const editFamilyGroup = reactive(new FamilyGroup())
const editProperties = ['name'] as (keyof FamilyGroup)[]
useInstantSave(familyGroupRef, editFamilyGroup, editProperties,
  changes => familyGroupStore.patchAsync(props.familyGroupId!, changes))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _hoisted_2,
        _createVNode(InPlaceTextEdit, {
          id: "nameInput",
          modelValue: editFamilyGroup.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editFamilyGroup.name) = $event)),
          required: "",
          disabled: !canEditRef.value
        }, null, 8, ["modelValue", "disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, [
        _createTextVNode(" Group owner "),
        (canEditRef.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-inline btn-link inline-action",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(notImplemented) && _unref(notImplemented)(...args)))
            }, " change "))
          : _createCommentVNode("", true)
      ]),
      _createVNode(UserItem, {
        "user-id": familyGroupRef.value?.ownerId,
        "no-hover": ""
      }, null, 8, ["user-id"])
    ]),
    _createElementVNode("div", null, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(_toDisplayString(_unref(DateTimeUtil).toUserActionDate(familyGroupRef.value?.createdDate)) + " ", 1),
        _createElementVNode("span", _hoisted_7, "(" + _toDisplayString(_unref(DateTimeUtil).toRelativePastDate(familyGroupRef.value?.createdDate)) + ")", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (canEditRef.value)
        ? (_openBlock(), _createElementBlock("button", _hoisted_9, [
            _createVNode(_unref(Trash2Icon)),
            _createTextVNode(" Delete group ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(Modal, {
      id: "deleteModal",
      ref_key: "deleteModalRef",
      ref: deleteModalRef,
      "ok-style": "danger",
      onOk: deleteGroup
    }, {
      title: _withCtx(() => [
        _createTextVNode("Delete group")
      ]),
      okIcon: _withCtx(() => [
        _createVNode(_unref(Trash2Icon))
      ]),
      okText: _withCtx(() => [
        _createTextVNode("Delete")
      ]),
      busyText: _withCtx(() => [
        _createTextVNode("Deleting...")
      ]),
      default: _withCtx(() => [
        _hoisted_10
      ]),
      _: 1
    }, 512)
  ]))
}
}

})